/* product-single.js v9 - show/hide slider with arrow fix (cancel transitions) */
(function() {
  function initSlider() {
    document.querySelectorAll(".product-section .product__media-list").forEach(function(list) {
      var items = list.querySelectorAll(".product__media-item");
      if (items.length < 2) return;
      var currentIndex = 0;
      list.classList.add("flickity-enabled");
      items.forEach(function(item, i) {
        if (i === 0) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
      function goTo(index) {
        if (index >= items.length) index = 0;
        if (index < 0) index = items.length - 1;
        items[currentIndex].style.display = "none";
        items[index].style.display = "block";
        currentIndex = index;
      }
      var wrapper = list.closest(".product__media-list-wrapper-outer");
      if (wrapper) {
        var arrows = wrapper.querySelectorAll(".product__media-list-wrapper-outer-arrow");
        arrows.forEach(function(a) {
          if (a.getAnimations) {
            a.getAnimations().forEach(function(anim) { anim.cancel(); });
          }
          a.style.setProperty("transition", "none", "important");
          a.style.setProperty("visibility", "visible", "important");
          a.style.setProperty("opacity", "1", "important");
        });
        var next = wrapper.querySelector(".product__media-list-wrapper-outer-arrow_next");
        var prev = wrapper.querySelector(".product__media-list-wrapper-outer-arrow_prev");
        if (next) next.addEventListener("click", function(e) { e.preventDefault(); e.stopPropagation(); goTo(currentIndex + 1); });
        if (prev) prev.addEventListener("click", function(e) { e.preventDefault(); e.stopPropagation(); goTo(currentIndex - 1); });
      }
    });
  }
  function initAccordion() {
    try {
      $(".product__additional").click(function() {
        if (!$(this).hasClass("active")) {
          $(".product__additional.active").removeClass("active");
          $(this).addClass("active");
          $(".product__additional-description").hide().eq($(this).index()).slideDown(300);
        }
      });
    } catch(e) {}
  }
  function boot() {
    initSlider();
    try { initModal("fancy-container-info"); } catch(e) {}
    initAccordion();
  }
  if (document.readyState === "complete") {
    setTimeout(boot, 100);
  } else {
    window.addEventListener("load", function() { setTimeout(boot, 100); });
  }
  document.addEventListener("shopify:section:load", function() { boot(); });
})();
